<template>
  <div>

    <b-breadcrumb class="justify-content-end">
      <b-breadcrumb-item class="mr-5">
        <b-button
          v-if="isDerivaciones"
          class="ml-1"
          variant="outline-secondary"
          size="sm"
          @click="descargarExcelCrudo"
          v-b-tooltip.hover
          title="Descargar Base Datos Derviaciones"
          :disabled = "descargandoBase"
        >
          <div v-if="descargandoBase">
            <b-spinner small type="grow"></b-spinner>
            <label>Descargando..</label> 
          </div>
          <i class="fas fa-file-alt"></i>
        </b-button>

        <b-button
          v-if="isDerivaciones"
          class="ml-1"
          variant="success"
          size="sm"
          @click="descargarExcel"
          v-b-tooltip.hover
          title="Descargar derivaciones IESS"
        >
          <i class="fas fa-file-excel"></i>
        </b-button>

      </b-breadcrumb-item>
    </b-breadcrumb>

    <b-card v-if="canViewFilters" class="shadow-lg rounded" >

      <b-row class="mt-1">
        <b-form-input 
          v-model="filters.search" 
          placeholder="Buscar por nombre o cedula el paciente..." 
          type="text"
          class="col-md-5" 
        />
        <b-col md="3">
          <v-select 
            v-model="filters.estadoDerivacion" 
            :options="estadoDerivacionOpts" 
            label="text"
            placeholder="Buscar por estado."
            :reduce="option => option.value" 
          />
        </b-col>

        <b-col md="2">
          <b-form-group>
            <flat-pickr 
              v-model="filters.fechaDesde" 
              placeholder="Fecha(desde):" 
              :config="configdateTimePicker"
              class="form-control" 
            />
          </b-form-group>
        </b-col>

        <b-col md="2">
          <b-form-group>
            <flat-pickr 
              v-model="filters.fechaHasta" 
              placeholder="Fecha(hasta):" 
              :config="configdateTimePicker"
              class="form-control" 
            />
          </b-form-group>
        </b-col>
        <b-col md="2">
          <v-select 
            v-model="filters.tipoServicio" 
            :options="optionsTipoServicio" 
            label="text"
            placeholder="Tipo de servicio."
            :reduce="option => option.value"
          />
        </b-col>
        <!-- <b-col md="2">
          <b-form-checkbox 
            v-model="filtrarPorCompletar"
            name="check-button" 
            switch
          >
            <b>Por completar</b>
          </b-form-checkbox>
        </b-col> -->

        <b-col cols="2" class="d-flex align-items-center justify-content-start mb-1 mb-md-0">
          <b-button variant="primary" @click="buscarDerivacion">
            <font-awesome-icon icon="magnifying-glass" style="color: white;" />
            <span style="color: white;"> Buscar</span>
          </b-button>
        </b-col>
      </b-row>
      
      <hr>  
      <h5 v-if="isDerivaciones">Administración de estados de las derivaciones</h5>
      <b-row  v-if="isDerivaciones">
        <b-col cols="3">
          <v-select 
            v-model="estadoderivacion" 
            :options="estadoDerivacionOpts" 
            label="text" 
            placeholder="Estados..."
          />
        </b-col>

        <b-col cols="4">
          <b-button variant="primary" @click="cambiarEstado"> Cambiar Estado </b-button>
          <b-button variant="info" @click="enviarCorreo" class="ml-1"> <i class="fas fa-envelope"></i></b-button>
        </b-col>
      </b-row>
    </b-card>


    <b-overlay 
      :show="mostrarLoader" 
      opacity="0.50" 
      rounded="sm"
    >
      <b-card class="principal">

        <b-skeleton-wrapper v-if="loadingTable">
          <b-skeleton 
            v-for="i in 15"
            :key="i"
            width="100%" 
            height="50px"
          />
        </b-skeleton-wrapper>

        <b-col v-if="!loadingTable" cols="12" class="pr-0 pl-0 mt-2">
          <b-table 
            v-if="items.length > 0" 
            bordered striped responsive 
            :per-page="perPage" 
            :current-page="currentPage"
            :items="derivacionesMap" 
            :fields="fields" 
            :sort-by.sync="sortBy" 
            :sort-desc.sync="sortDesc"
            :sort-direction="sortDirection"
            :filter="filter" 
            :filter-included-fields="filterOn"
            @filtered="onFiltered"
            small
          >
            <template #cell(check)="data">

              <b-form-checkbox :value="data.item.id" @change="toggleSelection(data.item.id)">
              </b-form-checkbox>
            </template>
            <template #cell(observacion)="data">
              <div>
                <label>{{ data.item.observacion }}</label>
              </div>
              <div>
                <label 
                  v-if="!data.item.urlTirilla"
                  style="color: red; background-color: pink; margin: auto; text-align: center;
                ">
                  Falta subir
                </label>
                <label v-else style="color: green; background-color: lemonchiffon; margin: auto; text-align: center;">
                  Tirilla Subida
                </label>
              </div>
            </template>
            <template #cell(msp)="data">
              <div>
                <label 
                  v-if="!data.item.urlMsp"
                  style="color: red; background-color: pink; margin: auto; text-align: center;">
                  Falta subir
                </label>
                <label v-else style="color: green; background-color: lemonchiffon; margin: auto; text-align: center;">
                  Msp Subido
                </label>

              </div>
            </template>

            <template #cell(acciones)="data">
              <div class="d-flex justify-content-end">

                <b-button 
                  variant="info" 
                  size="sm" 
                  @click="viewItem(data.item.tokenDerivacion)"
                >
                  <font-awesome-icon icon="magnifying-glass" style="color: white;" />
                </b-button>
                
                <b-button 
                  v-if="completeDerivaciones && data.item.estadoDerivacion.text === 'Por Completar'" 
                  variant="success"
                  @click="onCompletarDerivacion(data.item.tokenDerivacion)" 
                  v-b-tooltip.hover 
                  title="Completar Derivacion" 
                  size="sm"
                >
                  <i class="fa-solid fa-table-list"/>
                </b-button>

                <b-button 
                  v-if="completeDerivaciones && data.item.estadoDerivacion.text === 'Creado'" 
                  variant="warning"
                  @click="onCompletarDerivacion(data.item.tokenDerivacion)" 
                  v-b-tooltip.hover 
                  title="Completar Derivacion" 
                  size="sm"
                >
                  <font-awesome-icon icon="user-pen" style="color: white;" />
                </b-button>

                <b-button 
                  v-if="data.item.estadoDerivacion.text === 'No Aprobado'" 
                  variant="dark"
                  @click="explicarNegacionDerivacion(data.item.tokenDerivacion)" 
                  v-b-tooltip.hover 
                  title="Agregar comentario sobre negacion" 
                  size="sm"
                >
                  <i class="fa-solid fa-pencil"/>
                </b-button>


                <b-button  
                  v-if="isDerivaciones && data.item.estadoDerivacion.text !== 'Por Completar'" 
                  size="sm" 
                  variant="warning"
                  @click="navigateToQuery('tirilla', data.item.tokenDerivacion)" 
                  v-b-tooltip.hover 
                  title="Subir Tirilla Derivacion"
                >
                  <i class="fas fa-arrow-up"/>
                </b-button>
                <b-button 
                  v-if="isDerivaciones"
                  variant="danger" 
                  title="Eliminar"
                  size="sm" 
                  @click="onDeleteDerivacion(data.item.tokenDerivacion)"
                  v-b-tooltip.hover 
                >
                 <i class="fas fa-trash"/>
                </b-button>

                <b-button 
                  v-if="isDerivaciones"
                  variant="dark" 
                  title="observacion"
                  size="sm" 
                  @click="observacion(data.item.tokenDerivacion)"
                  v-b-tooltip.hover 
                >
                 <i class="fas fa-eye"/>
                </b-button>

              </div>
            </template>

            <template #cell(documentos)="data">
              <div v-if="data.item.estadoDerivacion.text !== 'Por Completar'" class="d-flex justify-content-end">
                <b-button 
                  variant="success" 
                  size="sm" 
                  v-b-tooltip.hover
                  title="Descargar formulario 053" 
                  @click="onViewFile053(data.item.tokenDerivacion, data.item.paciente)">
                  <i class="fas fa-file"/>
                </b-button>
              </div>
            </template>

            <template #cell(descripcion)="data">
              <div :id="'tooltip-target-' + data.index" v-b-tooltip.hover :title="data.item.descripcion">
                {{
                  data.item.descripcion.split(" ").slice(0, 14).join(" ") + "..."
                }}
              </div>
            </template>
          </b-table>


          <div v-else class="text-center">
            <p>No se encontraron registros</p>
          </div>
        </b-col>

        <b-col 
          cols="12" class="mb-2">
          <b-pagination 
            v-if="items.length > 0" 
            v-model="table.page" 
            :total-rows="table.totalRows"
            :per-page="table.size" 
            :small="true" 
            first-number 
            class="mb-0" align="center"
            prev-class="prev-item" 
            next-class="next-item" 
            @change="onChangePage"
          >
            <template #prev-text>
              <feather-icon icon="ChevronLeftIcon" size="18" />
            </template>
            <template #next-text>
              <feather-icon icon="ChevronRightIcon" size="18" />
            </template>
          </b-pagination>
        </b-col>
      </b-card>
    </b-overlay>


    <b-modal id="ver-derivacion" size="xl">
      <ver-derivacion :token="tokenDerivacion" />
    </b-modal>

    <b-modal id="editar-derivacion" size="xl" hide-footer>
      <editar-derivacion :token="tokenDerivacion" />
    </b-modal>

    <DerivacionModalCompletar />

    <DerivacionModalView />

    <ModalTirilla/>
    
    <ModalObservacion/>

    <ModalViewFile
      v-if="modalFile.fileToView"
      :urlFile="modalFile.fileToView"
      :rutaCompleta=modalFile.isRutaCompleta
      :nombreArchivo="modalFile.nombreArchivo"
      v-model="modalFile.isVisible"
    />

    <b-modal id="modal-obs-negacion" size="md" @ok="guardarComentarioNegacion">
      <h4><b>Agregar comentario sobre negacion:</b></h4>
      <div>
        <b-form-textarea v-model="obsnegacion">
        </b-form-textarea>
      </div>
      <template #modal-footer>
        <b-button variant="secondary" @click="$bvModal.hide('modal-obs-negacion')">Cancelar</b-button>
        <b-button variant="primary" @click="guardarComentarioNegacion">Guardar comentario</b-button>
      </template>
    </b-modal>


  </div>

</template>

<script>
import { BootstrapVue } from 'bootstrap-vue';
import actions from '@/assets/utils/utils'
import { comprobarPermisos, comprobarRoles, getEstablecimientoLS, getIdDoctorLS, getItemByValueId } from "@/shared/helpers";
import vSelect from 'vue-select'
import axios from 'axios';
import { ROLES } from '@/shared/constants';
import { ModalViewFile } from '@/shared/components';

import flatPickr from "vue-flatpickr-component";
import 'flatpickr/dist/flatpickr.css';
import rutas from '@/assets/utils/rutas.json';
import JSZip from "jszip";
import { v4 as uuidv4 } from 'uuid';
import { establecimientosService } from '@/views/administracion/services';
import { derivacionesService } from '../services';
import VerDerivacion from '../VerDerivacion.vue';
import { DerivacionModalCompletar, DerivacionModalView, ModalTirilla, ModalObservacion } from '../components';
import EditarDerivacion from '../EditarDerivacion.vue';


export default {
  components: {
    ...BootstrapVue.components,
    VerDerivacion,
    flatPickr,
    EditarDerivacion,
    DerivacionModalCompletar,
    DerivacionModalView,
    vSelect,
    ModalViewFile,
    ModalTirilla,
    ModalObservacion
  },
  data() {

    return {
      loadingTable: false,

      descargandoBase : false,
      idEstablecimiento : null,
      filters: {
        search     : null,
        estadoDerivacion : null,
        fechaDesde : null,
        fechaHasta: null,
        tipoServicio:null
      },
      obsnegacion: null,
      tokenDerActual : null,
      optionsTipoServicio : [
        { value:'1', text:'ATECION' },
        { value:'2', text:'LABORATORIO' },
        { value:'3', text:'IMAGEN' },
        { value:'4', text:'PROCEDIMIENTOS' },
        { value:'6', text:'EMERGENCIA' },
      ],

      table:{
        page: 1,
        size: 15,
        totalRows: 0
      },

      derivacionesRaw: [],
      derivacionesMap: [],
      edad: null,
      showModalActualizar: false,
      tirilla: {
        derivacion: null
      },
      msp: {
        paciente: null,
        titular1: null,
        titular2: null,
        titular3: null,
        titular4: null
      },
      esDerivacion: null,
      filtrarPorCompletar: false,
      estadoderivacion: null,

      estadoDerivacionOpts: [
        { value: "0", text: "Creado" },
        { value: "1", text: "Enrutado" },
        { value: "2", text: "Enviado Iess" },
        { value: "3", text: "Aprobado" },
        { value: "4", text: "No Aprobado" },
        { value: "5", text: "Entregado" },
        { value: "99", text: "Por Completar" },
      ],

      tipoAtencionOpts: [
        { value: 1, text: "Consulta Externa" },
        { value: 2, text: "Laboratorio" },
        { value: 3, text: "Imagen" },
        { value: 4, text: "Procedimientos Diagnósticos" },
        { value: 5, text: "Hospitalización" },
        { value: 6, text: "Emergencia" },
        { value: 7, text: "Tratamiento Integral Oncologico" }
      ],
      pacienteActual: '',
      idenrutados: null,
      totalenrutados: null,
      cargando: null,
      archivozip: null,
      itemspdf: null,
      excel: null,
      selectedIds: [],
      tokenSeleccionado: null,
      modalShow: false,
      componenteDinamico: null,
      pagina_actual: 1,
      currentPage: 1,
      currentPageModificado: 1,
      mostrarLoader: false,
      login_user: '',
      consultarderivacion: null,
      consultarestablecimiento: '',
      establecimientosOpts: [],
      establecimiento: '',
      consultartipoImagen: '',
      tipoImagen: '',
      tiposImagen: [],
      perPage: 15,
      pageOptions: [3, 5, 10],
      totalRows: 3,
      sortBy: '',
      sortDesc: false,
      sortDirection: 'asc',
      filter: null,
      filterOn: [],
      zip: null,
      tokenCita: null,
      correo: null,

      infoModal: {
        id: 'info-modal',
        title: '',
        content: '',
      },

      fields: [
        { key: 'check',                  label: '',                  thClass: 'text-center' },
        { key: 'paciente',               label: 'Paciente',          sortable: true, thClass: 'text-center' },
        { key: 'cobertura',              label: 'Cobertura',      sortable: true, thClass: 'text-center' },
        { key: 'estadoDerivacion.text',  label: 'Estado',            sortable: true, thClass: 'text-center' },
        { key: 'tipoderivacion',         label: 'Tipo Derivacion',      sortable: true, thClass: 'text-center' },
        { key: 'feccita',                label: 'Fecha Cita',        sortable: true, thClass: 'text-center' },
        { key: 'fecderivacion',          label: 'Fecha Derivacion',  sortable: true, thClass: 'text-center' },
        { key: 'feccambio',              label: 'Fecha Estado',      sortable: true, thClass: 'text-center' },
        { key: 'doctor',                 label: 'Doctor',            sortable: true, thClass: 'text-center' },
        { key: 'especialidad',           label: 'Especialidad',      sortable: true, thClass: 'text-center' },
        { key: 'observacion',            label: 'Observaciones / Tirilla',     sortable: true, thClass: 'text-center' },
        { key: 'acciones',               label: 'acciones',          sortable: true, thClass: 'text-center', tdClass: 'text-right' },
        { key: 'documentos',             label: 'documentos',        sortable: true, thClass: 'text-center', tdClass: 'text-right' },
      ],

      listaAcciones: [],
      token_usuario: '',
      configdateTimePicker: {
        enableTime: false,
        dateFormat: 'Y-m-d',
      },
      tokenDerivacion: null,
      items: [],
      descripcion: '',
      itemexcel: null,


      modalFile:{
        fileToView: null,
        isVisible: false,
        isRutaCompleta: false,
        nombreArchivo: null
      },

      load053: false
    }
  },

  async created() {
    this.setToken();
    comprobarPermisos(this.$route);
    this.establecimientosOpts = await establecimientosService.getForSelect();
    this.loadDataTable();
  },

  computed: {
    canViewFilters(){
      return comprobarRoles([ROLES.DERIVADOR, ROLES.JEFE_DERIVADOR, ROLES.DOCTOR, ROLES.JEFE_MEDICO, ROLES.ADMISION, ROLES.AUDITOR, ROLES.JEFE_AUDITOR]);
    },

    isDerivaciones(){
      return comprobarRoles([ROLES.DERIVADOR, ROLES.JEFE_DERIVADOR]);
    },

    completeDerivaciones(){
      return comprobarRoles([ROLES.DOCTOR, ROLES.JEFE_MEDICO, ROLES.DERIVADOR, ROLES.JEFE_DERIVADOR]);
    },

    isDoctor() {
      return comprobarRoles([ROLES.DOCTOR, ROLES.JEFE_MEDICO]);
    },

    isAdmin(){
      return comprobarRoles([ROLES.ADMINISTRADOR]);
    }
  },

  mounted() {
    actions.setearTitulo('Derivaciones')
    this.fetchDerivaciones();
  },


  methods: {

    navigateToQuery(queryParam, valueQuery) {
      try {
        this.$router.push({
          path: this.$route.path,
          query: {
            ...this.$route.query,
            [queryParam]: valueQuery,
          },
        });
      } catch (error) {
        console.error("Error en la navegación:", error);
      }
    },

    async explicarNegacionDerivacion(tokenDerivacion) {
      this.obsnegacion = ''
      this.tokenDerActual = tokenDerivacion
      this.$bvModal.show('modal-obs-negacion')
      
    },

    async guardarComentarioNegacion(){
      const query = `
        mutation MyMutation($tokenDerivacion : String!, $obsNegacion : String!) {
          explicarNegacionDerivacion(tokenDerivacion: $tokenDerivacion, obsNegacion: $obsNegacion) {
            message
            status
          }
        }
      `;

      const variables = {
        tokenDerivacion: this.tokenDerActual,
        obsNegacion : this.obsnegacion
      }
      try {
        const response = await axios.post(rutas.axios + "api", { query, variables });
        
        if (response.data.data.explicarNegacionDerivacion.status === 'success') {
          await this.$swal.fire({
            title: 'Exito',
            text: "Se ha agregado el comentario",
            icon: 'success',
            confirmButtonColor: '#3085d6',
            confirmButtonText: 'Entendido',
          })
          this.$router.go(0)
        }else{
          await this.$swal.fire({
            title: 'Error',
            text: "Comentario no agregado",
            icon: 'warning',
            confirmButtonColor: '#3085d6',
            confirmButtonText: 'Entendido',
          })
        }
        
      }catch (error) {
        console.error("Error al cargar los titulares", error);
        await this.$swal.fire({
          title: 'Error',
          text: 'Comentario no agrgado',
          icon: 'warning',
          confirmButtonColor: '#3085d6',
          confirmButtonText: 'Entendido',
        })
      }
    },

    async fetchTitularesPaciente(idpaciente) {
      const query = `
        query MyQuery($idpaciente : String!) {
          gettitulares(paciente: $idpaciente ) {
            total
            status
            message
            titular {
              estado
              id
            }
          }
        }
      `;

      const variables = {
        idpaciente: idpaciente
      }
      try {
        const response = await axios.post(rutas.axios + "api", { query, variables });
        if (response.status === 200) {
          if (response.data.data.gettitulares.total > 0) {
            const cantTitulares = response.data.data.gettitulares.total
            return cantTitulares
          }
        }
      }
      catch (error) {
        console.error("Error al cargar los titulares", error);
      }
    },


    onCompletarDerivacion(derivaciontoken) {
      this.$router.push({ name: "derivaciones", query: { completar: derivaciontoken } });
    },

    async loadDataTable() {

      this.loadingTable = true;

      const doctorId = getIdDoctorLS();
      const establecimientoUser = getEstablecimientoLS();
      this.idEstablecimiento = establecimientoUser.id;

      const params = {
        search           : this.filters.search?.trim(),
        estadoDerivacion : this.filters.estadoDerivacion,
        establecimiento  : this.idEstablecimiento,
        tipoServicio     : this.filters.tipoServicio,
        fechaDesde       : this.filters.fechaDesde,
        fechaHasta       : this.filters.fechaHasta,

        doctorId         : doctorId,
        page             : this.table.page,
        pageSize         : this.table.perPage
      };
      const data = await derivacionesService.getAll(params);
      this.derivacionesRaw = data.derivaciones;
      this.table.totalRows = data.total;
      this.derivacionesMap = this.mapDerivaciones();
      this.loadingTable = false;
    },

    onChangePage(page){
      this.table.page = page;
      this.loadDataTable();
    },

    mapDerivaciones() {
      if (this.derivacionesRaw?.length === 0) return null;

      let estadoDerivacion = null;
      const derivacionesMapped = this.derivacionesRaw.map(d => {
        estadoDerivacion = getItemByValueId(this.estadoDerivacionOpts, d.estadoDerivacion);
        const paciente = d.atenmedId.cita.paciente.persona;
        const doctor = d.atenmedId.cita.doctor.idPersona;

        // Determinar el valor de especialidad según tipoAtencion
        let especialidadValue = d.especialidad?.descripcion || "No disponible";
        if (d.tipoAtencion === "2") { // Cambiar a string "2"
          especialidadValue = "Laboratorio";
        } else if (d.tipoAtencion === "3") { // Cambiar a string "3"
          especialidadValue = "Imagen";
        }

        // Agregar console.log para depuración
        console.log({
          id: d.id,
          tipoAtencion: d.tipoAtencion,
          tipoAtencionType: typeof d.tipoAtencion, // Agregar tipo para confirmar
          especialidadOriginal: d.especialidad?.descripcion,
          especialidadValue: especialidadValue
        });

        const newDerivacion = {
          id: d.id,
          tokenDerivacion: d.token,
          establecimiento: d.atenmedId.cita.establecimiento.Descripcion || "No disponible",
          paciente: `${paciente.identificacion} - ${paciente.primerApellido} ${paciente.primerNombre}` || "No disponible",
          doctor: `${doctor.primerNombre} ${doctor.primerApellido}` || "No disponible",
          especialidad: especialidadValue,
          identificacion: paciente.identificacion || "No disponible",
          motivo: d.motivoderivacionId?.descripcion || "No disponible",
          feccita: d.atenmedId.cita.fechaCita || "",
          cobertura: d.atenmedId.cita.cobSeleccionada?.descripcion || "",
          tipoderivacion: d.tipoderivacionId?.descripcion || "",
          feccambio: d.fechaCambio || "Sin cambios",
          fecderivacion: d.fechaDerivacion || "No disponible",
          tipoServicio: getItemByValueId(this.tipoAtencionOpts, d.tipoAtencion),
          observacion: d.observacion ? d.observacion : "",
          estadoDerivacion,
        };
        return newDerivacion;
      });
      return derivacionesMapped;
    },

    base64ToArrayBuffer(base64) {
      const binaryString = window.atob(base64); // Decodifica la cadena base64
      const len = binaryString.length;
      const bytes = new Uint8Array(len);
      for (let i = 0; i < len; i++) {
        bytes[i] = binaryString.charCodeAt(i);
      }
      return bytes.buffer;
    },

    async generate_PDF(item, nombres, identificacion) {
      const pdf = new JSZip();

      for (let i = 0; i < item.length; i++) {
        const uuid = uuidv4();
        const contenidoPDF = this.base64ToArrayBuffer(item[i]);
        pdf.file(`derivacion-${uuid}.pdf`, contenidoPDF);
      }

      const contenidoFinalPDF = await pdf.generateAsync({ type: "base64" });
      
      this.downloadPDF(contenidoFinalPDF, `${identificacion}-${nombres}.pdf`);
      return contenidoFinalPDF;
    },

    async downloadPDF(base64, fileName) {
      const link = document.createElement('a');
      
      const byteCharacters = atob(base64);
      const byteArrays = [];
      
      for (let offset = 0; offset < byteCharacters.length; offset += 512) {
        const slice = byteCharacters.slice(offset, offset + 512);
        const byteNumbers = new Array(slice.length);
        for (let i = 0; i < slice.length; i++) {
          byteNumbers[i] = slice.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        byteArrays.push(byteArray);
      }

      // Cambiar el tipo MIME a 'application/pdf' ya que estamos descargando un PDF
      const blob = new Blob(byteArrays, { type: 'application/pdf' });

      // Crear un objeto URL para el Blob
      const url = URL.createObjectURL(blob);

      link.href = url;
      link.download = fileName;
      link.click();

      URL.revokeObjectURL(url);
    },




    async generateZip(item, nombres, identificacion) {
      const zip = new JSZip();
      for (let i = 0; i < item.length; i++) {
        const uuid = uuidv4();
        const contenidoPDF = this.base64ToArrayBuffer(item[i]);
        zip.file(`derivacion-${uuid}.pdf`, contenidoPDF);
      }

      // zip.generateAsync({ type: "base64" })
      //   .then((base64) => base64);
      this.archivozip = await zip.generateAsync({ type: "base64" });
      this.downloadZip(this.archivozip, `${identificacion}-${nombres}-derivacion.zip`);
      return this.archivozip
    },

    async downloadZip(base64, fileName) {
      const link = document.createElement('a');
      
      const byteCharacters = atob(base64);
      const byteArrays = [];
      
      for (let offset = 0; offset < byteCharacters.length; offset += 512) {
        const slice = byteCharacters.slice(offset, offset + 512);
        const byteNumbers = new Array(slice.length);
        for (let i = 0; i < slice.length; i++) {
          byteNumbers[i] = slice.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        byteArrays.push(byteArray);
      }

      const blob = new Blob(byteArrays, { type: 'application/zip' });

      // Crear un objeto URL para el Blob
      const url = URL.createObjectURL(blob);
  
      link.href = url;
      link.download = fileName;  // Nombre del archivo que se descargará
      link.click();

      URL.revokeObjectURL(url);
    },


    async enviarCorreo() {

      if (this.totalEnrutados === 0) {
        this.$swal({
          title: 'Sin elementos para enviar',
          text: "Cambie el estado de los elementos a 'ENRUTADO' para enviar por correo",
          icon: 'warning',
          confirmButtonColor: '#3085d6',
          confirmButtonText: 'Entendido',
        })

      } else {

        const query = `
          mutation MyMutation($asunto: String!, $destinatarios: [String!]!, $mensaje: String!, $archivo : String!, $archivozip : String! ) {
            enviarCorreo(asunto: $asunto, destinatarios: $destinatarios, mensaje: $mensaje, archivo : $archivo, archivozip : $archivozip) {
              resultado
            }
          }
        `;

        this.correo = '1';

        try {
          this.cargando = true

          const loadingSwal = this.$swal({
            title: 'Enviando...',
            icon: 'info',
            showConfirmButton: false,
            allowOutsideClick: false,
            willOpen: () => {
              this.$swal.showLoading();
            }
          });

          await this.fetchDerivaciones(null, '1', '', 1, '', 15);
          const itemexcel = this.itemexcel;
          await this.descargarPDFS();
          const itemzip = this.archivozip;

          const variables = {
            asunto: "Departamento de Derivaciones SERVIDENT",
            destinatarios: ["alt.b7-3g8yxe6@yopmail.com"],
            mensaje: "Le estamos enviando este correo de parte de derivaciones servident: Espero que este mensaje le encuentre bien. Por medio de la presente, le informo que hemos realizado la derivación de los pacientes que se detallan a continuación al Instituto Ecuatoriano de Seguridad Social (IESS) para su atención especializada. Agradecemos su pronta gestión y colaboración en el proceso.",
            archivo: itemexcel,
            archivozip: itemzip
          };

          const response = await axios.post(rutas.axios + "api", {
            query, variables
          });

          if (response.data.data.enviarCorreo.resultado === true) {
            this.cargando = false
            if (this.cargando = false) {
              loadingSwal.close();
            }
            await this.$swal({
              title: 'Éxito',
              text: 'Éxito en el envio del correo',
              icon: 'success',
              confirmButtonColor: '#089599'
            });

            await this.cambiarEstado('1');
            this.$router.go(0);
          }

          else if (response.data.data.enviarCorreo.resultado === false) {
            this.cargando = false
            if (this.cargando = false) {
              loadingSwal.close();
            }
            await this.$swal({
              title: 'Error',
              text: 'Hubo un error al intentar enviar el correo',
              icon: 'error',
              confirmButtonColor: '#089599'
            });
          }

        } catch (error) {
          console.error("Error", error);
          await this.$swal({
            title: 'Error',
            text: 'Hubo un error al intentar enviar el correo',
            icon: 'error',
            confirmButtonColor: '#089599'
          });
        }
      }
    },

    isSelected(id) {
      return this.selectedIds.includes(id);
    },

    toggleSelection(id) {
      const index = this.selectedIds.indexOf(id);
      if (index === -1) {
        this.selectedIds.push(id);
      } else {
        this.selectedIds.splice(index, 1);
      }
    },

    async cambiarEstado(idsenrutados) {
      const query = `
        mutation MyMutation($estadoDerivacion: String!, $idsDerivacion: [ID!]!) {
          actualizarEstadoDerivacion(inputData: {estadoDerivacion: $estadoDerivacion, idsDerivacion: $idsDerivacion}) {
            message
            status
            derivaciones {
              id
            }
          }
        }
      `;

      const estadoderivacion = this.estadoderivacion ? this.estadoderivacion.value : null;
      let variables = {}

      if (idsenrutados === '1') {
        variables = {
          estadoDerivacion: '2',
          idsDerivacion: this.idenrutados
        }
      } else {
        variables = {
          estadoDerivacion: estadoderivacion,
          idsDerivacion: this.selectedIds
        }
      }


      try {
        const response = await axios.post(rutas.axios + "api", { query, variables });

        if (response.data.data.actualizarEstadoDerivacion.status === "success") {
          await this.$swal({
            title: 'Éxito',
            text: 'Éxito en el cambio de estado',
            icon: 'success',
            confirmButtonColor: '#089599'
          });

          this.$router.go(0)
        }
      } catch (error) {
        console.error("Error", error);
        await this.$swal({
          title: 'Error',
          text: 'Hubo un error al intentar cambiar el estado',
          icon: 'error',
          confirmButtonColor: '#089599'
        });
      }
    },

    
    async calcularEdad(fechaNacimiento) {
      const hoy = new Date();
      const nacimiento = new Date(fechaNacimiento);
      let edad = hoy.getFullYear() - nacimiento.getFullYear();
      const mes = hoy.getMonth() - nacimiento.getMonth();

      // Si no ha cumplido años este año, se resta 1
      if (mes < 0 || (mes === 0 && hoy.getDate() < nacimiento.getDate())) {
        edad--;
      }

      return edad;
    },
    async descargarExcelCrudo() {
      this.descargandoBase = true
      let excel = "2";
      this.fetchDerivaciones(null, excel, '', 1, '', 15);
    },
    async descargarExcel() {
      let excel = "1"
      this.fetchDerivaciones(null, excel, '', 1, '', 15)
    },
    async modalCrear() {
      this.fetchDerivaciones(null, excel, '', 1, '', 15)
    },
    async onViewFile053(tokenInterconsulta, nombresPaciente = "Informe 053") {
      this.load053 = true;
      const urlTemp = await derivacionesService.getUrlView053(tokenInterconsulta, '1');
      if (!urlTemp) {
        this.load053 = false;
        this.$swal({
          title: 'Error',
          text: "El archivo no existe, comunicar con el adminsitrador sistema",
          icon: 'error',
        })
      }
      actions.cargarArchivos(
        urlTemp,
          nombresPaciente.trim()+".pdf",
          "data:application/pdf;base64"
      );
    },
    async documentoInforme005(idProceso, names) {
      const nombres = names.trim()
      const variables = {
        id: parseInt(idProceso, 10)
      }
      const query = `
        query MyQuery($id : Int!) {
          generatePdf(id: $id) {
            pdfBase64
          }
        }
      `;
      try {
        const response = await axios.post(rutas.axios + "api", { query, variables });

        if (response.data.data.generatePdf.pdfBase64) {
          const item = response.data.data.generatePdf.pdfBase64;

          actions.cargarArchivos(
            item,
            nombres + ".pdf",
            "data:application/pdf;base64"
          );

        } else {
          
          this.$swal({
            title: "Error",
            text: `El archivo no existe `,
            icon: "error",
            confirmButtonColor: "#089599",
          });
        }
      } catch (error) {
        console.error(error);
        this.$swal({
          title: "Error",
          text: `Error al descargar el archivo ${error}`,
          icon: "error",
          confirmButtonColor: "#089599",
        });
      }
    },
    async descargarPDFS() {
      this.zip = '1'
      const query = `
        query MyQuery {
          generateMultipleIndividualPdfs {
            pdfBase64List
          }
        }
      `;
      try {
        const response = await axios.post(rutas.axios + "api", { query });

        if (response) {
          this.itemspdf = response.data.data.generateMultipleIndividualPdfs.pdfBase64List;
          const itempdf = this.itemspdf;
          await this.generateZip(itempdf);

        } else {
          console.error("Error al descargar el archivo:", error);
          this.$swal({
            title: "Error",
            text: "El archivo no existe, comunicar con el adminsitrador sistema",
            icon: "error",
            confirmButtonColor: "#089599",
          });
        }
      } catch (error) {
        console.error(error);
        this.$swal({
          title: "Error",
          text: "Error al descargar el archivo",
          icon: "error",
          confirmButtonColor: "#089599",
        });
      }
    },

    async submitChildForm() {

      if (this.$refs.EditarItemCarteraAtencion) {
        await this.$refs.EditarItemCarteraAtencion.submitForm();
      }
    },

    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length
    },


    async fetchDerivaciones(
      estadoDerivacion = null, 
      exc = null, search = '', 
      paginaActual = 1, 
      establecimiento = '',
      pageSize
    ) {

      const establecimientoUser = getEstablecimientoLS();
      const idDoctor = getIdDoctorLS();

      const query = `
        query MyQuery( 
          $estadoderivacion: String, 
          $excel: String, 
          $page:Int,
          $espCom: Int, 
          $pageSize: Int, 
          $search: String, 
          $establecimiento: String,
          $doctorId   : String,
          $fechaDesde : String,
          $fechaHasta : String,
          $tipoServicio: String


        ) { 
          allDerivacionesenviadas( 
            estadoderivacion: $estadoderivacion, 
            excel: $excel, 
            page: $page, 
            espCom: $espCom, 
            pageSize: $pageSize, 
            search: $search, 
            establecimiento: $establecimiento,
            doctorId: $doctorId,
            fechaDesde: $fechaDesde,
            fechaHasta : $fechaHasta,
            tipoServicio: $tipoServicio
          ) {
            message
            status
            total

            dataarchivo
            derivaciones {
              id
              token
              atenmedId {
                cita {
                  paciente {
                  id
                    persona {
                      identificacion
                      primerNombre
                      primerApellido
                      fechaNacimiento
                    }
                  }               
                  doctor {
                    idPersona {
                      primerNombre
                      primerApellido
                    }
                    especialidad {
                      descripcion
                    }
                  }
                  establecimiento {
                    Descripcion
                  }
                }
              }
              motivoderivacionId {
                descripcion
              }
              especialidad{
                descripcion
              }
              fechaDerivacion
              estadoDerivacion
              tipoAtencion
              urlTirillaDerivacion
              urlMsp

            }
          }
        }
      `;
      const excel = exc
      const estadoderivacion = estadoDerivacion
      const zip = this.zip
      const filxc = this.filtrarPorCompletar ? 1 : 0 || 0;
      const variables = {
        search         : search,
        page           : paginaActual,
        pageSize       : pageSize,
        espCom         : filxc,
        doctorId       : idDoctor,
        establecimiento: this.isAdmin ? '0' : establecimientoUser.id,
        estadoderivacion: estadoderivacion,
        excel: excel,
        fechaDesde : this.filters.fechaDesde,
        fechaHasta: this.filters.fechaHasta,
        tipoServicio: this.filters.tipoServicio ? this.filters.tipoServicio.value : ''
      }

      try {
        const response = await axios.post(rutas.axios + 'api', { query, variables });
        if (response.status !== 200) return;
        const response2 = response.data.data.allDerivacionesenviadas;
        if (response2.status !== 'Success') return;

        if (response2.derivaciones) {
          if (excel === null) {

            this.items = response.data.data.allDerivacionesenviadas.derivaciones.map(item => {
              let estadoderivacion = 'No dispobible';
              if (item.estadoDerivacion) {
                if (item.estadoDerivacion === '0') {
                  estadoderivacion = 'Creado'
                }
                if (item.estadoDerivacion === '1')
                  estadoderivacion = 'Enrutado'

                if (item.estadoDerivacion === '2')
                  estadoderivacion = 'Enviado IESS'

                if (item.estadoDerivacion === '3')
                  estadoderivacion = 'Aprobado'

                if (item.estadoDerivacion === '4')
                  estadoderivacion = 'No Aprobado'

                if (item.estadoDerivacion === '5')
                  estadoderivacion = 'Entregado'

                if (item.estadoDerivacion === "99")
                  estadoderivacion = "Por Completar"
              }

              const dataPaciente = item.atenmedId.cita.paciente;
              const dataDoctor = item.atenmedId.cita.doctor;

              let especialidadValue = item.especialidad?.descripcion || "No disponible";
              if (item.tipoAtencion === '2') {
                especialidadValue = "Laboratorio";
              } else if (item.tipoAtencion === '3') {
                especialidadValue = "Imagen";
              }

              console.log({
                id: item.id,
                tipoAtencion: item.tipoAtencion,
                especialidadOriginal: item.especialidad?.descripcion,
                especialidadValue: especialidadValue
              });

              return {
                id                 : item.id,
                tokenDerivacion    : item.token,
                identificacion     : dataPaciente.persona.identificacion  || "",
                paciente           : `${dataPaciente.persona.identificacion} - ${dataPaciente.persona.primerApellido} ${dataPaciente.persona.primerNombre}` || "No disponible",
                fechaNacimiento    : dataPaciente.persona.fechaNacimiento || "",
                establecimiento    : item.atenmedId.cita.establecimiento.Descripcion || "No disponible",
                doctor             : `${dataDoctor.idPersona.primerNombre} ${item.atenmedId.cita.doctor.idPersona.primerApellido}` || "No disponible",
                especialidadOrigen : dataDoctor.especialidad.descripcion || "No disponible",
                especialidad       : especialidadValue,
                motivo             : item.motivoderivacionId ? item.motivoderivacionId.descripcion : "No disponible",
                atencion           : item.tipoAtencion ? this.tipoAtencionOpts[item.tipoAtencion - 1].text : '',
                urlTirilla         : item.urlTirillaDerivacion || "",
                urlMsp             : item.urlMsp || "",
                fecderivacion      : item.fechaDerivacion || "No disponible",
                estadoDerivacion   : estadoderivacion
              };
            });

            this.totalRows = response.data.data.allDerivacionesenviadas.total;
            this.currentPage = 1;
            this.currentPageModificado = paginaActual;
            let totalEnrutados = 0;
            const idsenrutados = [];
            response.data.data.allDerivacionesenviadas.derivaciones.forEach(item => {
              if (item.estadoDerivacion === '1') {
                totalEnrutados++
                idsenrutados.push(item.id)
              }
            });
            this.totalEnrutados = totalEnrutados
            this.idenrutados = idsenrutados
          }

          let correo = this.correo;
          if (excel === '1' && correo !== '1') {
            const data = response.data.data.allDerivacionesenviadas.dataarchivo
            actions.cargarArchivos(data, "derivaciones.xlsx", "data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64")
          }
          if (excel === '1' && correo === '1') {
            this.itemexcel = response.data.data.allDerivacionesenviadas.dataarchivo
            this.correo = null;
          }
          if (excel === '2') {
            const data = response.data.data.allDerivacionesenviadas.dataarchivo
            this.correo = null;
            actions.cargarArchivos(data, "derivacionesdb.xlsx", "data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64")
            this.descargandoBase = false
          }
        } else {
          console.log("No se encontraron derivaciones");
        }
        
      } catch (error) {
        console.error("Error fetching imagenes:", error);
        this.descargandoBase = false
      }
    },
    buscarDerivacion() {
      this.loadDataTable();
    },
    viewItem(tokenDerivacion) {
      this.$router.push({ name: 'derivaciones', query: { view_derivacion: tokenDerivacion } })
    },
    editItem(tokenDerivacion) {
      this.tokenDerivacion = tokenDerivacion;
      this.$bvModal.show("editar-derivacion");
    },
    observacion(tokenDerivacion) {
      this.tokenDerivacion = tokenDerivacion;
      this.navigateToQuery("observacion", tokenDerivacion);
    },
    async onDeleteDerivacion(tokenDerivacion) {
      const response = await this.$swal({
        title              : 'Estas seguro de eliminar este item?',
        text               : "No seras capaz de revertir esto!",
        icon               : 'warning',
        showCancelButton   : true,
        confirmButtonColor : '#3085d6',
        cancelButtonColor  : '#d33',
        confirmButtonText  : 'Si, Borrar esto!',
        cancelButtonText   : 'No, cancelar!'
      })
      if (!response.isConfirmed) return;

      try {
        const responseDelete = await derivacionesService.deleteRegistro(tokenDerivacion);

        if(!responseDelete) return

        await this.$swal({
          title: "Eliminado!",
          text: "El item ha sido eliminado.",
          icon: "success",
          confirmButtonColor: "#3085d6",
          confirmButtonText: "Ok"
        });

        this.$router.go(0);

      }catch (error) {
        console.error(error);
      }
    },

    setToken() {
      const user = JSON.parse(localStorage.getItem('usuario'))
      this.login_user = user.username
      axios.defaults.headers.common.Authorization = `JWT ${user.token}`
    },

    info(item, index, button) {
      this.infoModal.title = `Row index: ${index}`
      this.infoModal.content = JSON.stringify(item, null, 2)
      this.$root.$emit('bv::show::modal', this.infoModal.id, button)
    },
  },

}
</script>